import axios from 'axios'

export default {
  namespaced: true,
  state: {
    user_code: []
  },
  getters: {
    getUserCode:(state)=>state.user_code,
  },
  mutations: {
    setUserCode (state, data) {
      state.user_code = data
    }
  },
  actions: {
    async post(context, user) {
      await axios.post(process.env.VUE_APP_API_BASE_URL + '/password_reset/', user)
    },
    async patch(context, request) {
      await axios.patch(process.env.VUE_APP_API_BASE_URL + '/password_reset/', request)
    },
  }
}